/**
 * created by lei lei on 2020/5/28
 * 待我处理的活动
 */
import React, {Component} from 'react';
import ActivityPending from './NewActivityPending';
import {Empty, Modal, Tabs,Row,Col} from "antd";
import {headers, myReviewGridData} from "../../../../actions";
import {applicationName, uuid} from "../../../../utils";
import {NAVIGATE_CLOSE, NAVIGATE_OPEN} from "../../../../constants";
import EditWeiBo from "../../../../components/weibo/editWeiBo";
import {timeago} from '../../../../utils/index'
import {connect} from "react-redux";
import {MaterialModel} from "../../../../containers/weiChatPublish";
import {Scrollbars} from "react-custom-scrollbars";
const { TabPane } = Tabs;

//不要随便删除下面   global layer * 这个代码
/* global layer */
let that;
export class ActivityPendingComponentsOtherGwxw extends Component {
    static defaultProps = {}
    static propTypes = {}

    // 微信参数
    weChatParams = {
        title : "编辑素材",
        materialId : 0,
        mediaCode : ""
    };

    constructor(props) {
        super(props);
        this.state = {
            num1:0,
            num2:0,
            list:[],
            myAuditdatas: [],
            myMessageData: [],
            height:window.innerHeight-100,
            myMessageloading: false,
            myAuditloading: false,
            editWeiboVisible:false,
            downloadSourceNumber: 0,
            needTodoCount:0,
            editModalVisible: false,
            visible:false
        }
        that=this;
    }

    componentWillMount() {
    }

    componentDidMount()
    {
        this.getMyOtherDate();
    }

    callback(key){
        this.getMyOtherDate();
    }

    getMyOtherDate()
    {
        getMyOther((data)=>{
            if(data)
            {
                let storyList = data.data;
                let dataList = [];
                let forNum = 6;
                //  if(storyList.length <= forNum)
                // {
                forNum = storyList.length;
                // }
                for(let i = 0; i < forNum; i++)
                {
                    let story = storyList[i].object;
                    let type = this.getTitle(storyList[i]).type;
                    let icon = this.getIcon(storyList[i]);
                    let listObj = {};
                    let title=this.getTitle(storyList[i]).title;
                    listObj.record = storyList[i];
                    listObj.title = type;
                    listObj.icon = icon;
                    listObj.content = title?title:story.content;
                    if(story._deploymentKey && story._deploymentKey=="weixin")
                    {
                        if(story.stuffList && story.stuffList.length > 0)
                        {
                            listObj.content = story.stuffList[0].title;
                        }
                    }
                    listObj.statusMark = story.statusName;
                    listObj.timeMark =story.updateTime?timeago(story.updateTime):story.changeDate?timeago(story.changeDate.time):(story.updateDate?timeago(story.updateDate.time):"时间错误");
                    dataList.push(listObj);
                }


                this.setState({
                    num1 : data.total,
                    list : dataList
                })
            }
        });
    }
    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    render()
    {
        let menuWidth = parseInt(NAVIGATE_OPEN);
        if(!this.props.navigateStatus)
        {
            menuWidth = parseInt(NAVIGATE_CLOSE);
        }
        let dialogWidth = window.innerWidth;
        let layoutWidth = (((dialogWidth - menuWidth - 40 - 40 - 80)*0.45 - 20)/3);
        let minWidth = 180;
        if(layoutWidth <= minWidth)
        {
            layoutWidth = minWidth;
        }

        let itemNum = this.state.list.length;//6;//原来6条最后老赵让修改加滚动条，全部展示的。
        let itemWidth = 8;
        if(dialogWidth <= 1550)
        {
            //itemNum = 4;//这块展示全部的数据
            itemWidth = 12;
        }

        return (
            <div className={'ActivityPendingComponents StaticMyDeskItemPaddingTop'} style={{width: '100%'}}>
                <div style={{background: '#FFFFFF', position:'relative'}}>
                    <div style={{
                        height: 56,
                        lineHeight: '56px',
                        background: 'white',
                        width: '100%',
                        float: 'left',
                    }}>
                        <Tabs defaultActiveKey="1" onChange={(key)=>{this.callback(key)}}>
                            <TabPane tab={"稿件及资源申请"+"("+this.state.num1+")"} key="1"></TabPane>
                        </Tabs>
                        {/* <div onClick={() => {
                            this.setState({visible:true})
                        }} style={{
                            fontSize: 13,
                            right: 0,
                            color: '#0050B3',
                            float: 'right',
                            marginRight: 20,
                            cursor: 'pointer',position:'absolute',top:-7
                        }}>
                            <img src={moreImg} alt=""/>
                        </div>
                        <Modal
                            title="待我处理"
                            width={900}
                            visible={this.state.visible}
                            onOk={()=>{this.setState({visible:false})}}
                            onCancel={()=>{this.setState({visible:false})}}
                        >
                            <ActivityPendingAllComponents/>
                        </Modal>*/}
                    </div>
                    <div style={{clear: 'both'}}/>
                    <div style={(()=>{
                        return this.state.list.length===0?{textAlign:'center',height:360}:{height:360}
                    })()}>
                        <Scrollbars>
                            <Row>
                                {this.state.list.length===0?<div style={{paddingTop:115}}><Empty/></div>:this.state.list.map((item,i)=>{
                                    if(i<itemNum){
                                        return(

                                            <Col key={i} span={itemWidth}>
                                                {/*  <div key={i} style={{float: 'left'}}>*/}
                                                <ActivityPending
                                                    title={item.title}
                                                    iconType={1}
                                                    customWidth={layoutWidth}
                                                    content={item.content}
                                                    statusMark={item.statusMark}
                                                    timeMark={item.timeMark}
                                                    showPoint={false}
                                                    showX={false}
                                                    onClickItem={() => {
                                                        this.chekcData(item.record);
                                                    }}
                                                    onRemoveItem={()=>{
                                                        console.log('点击了删除')
                                                    }}
                                                />
                                                {/* </div>*/}
                                            </Col>
                                        )
                                    }

                                })}
                            </Row>
                        </Scrollbars>
                    </div>
                </div>
                <Modal key={uuid()}
                       title={"编辑微博"}
                       visible={this.state.editWeiboVisible}
                       onCancel={this.closeWeibo.bind(this)}
                       bodyStyle={{height:"570px"}}
                       width={860}
                       footer={null}
                       keyboard={false}
                       maskClosable={false}
                >
                    <EditWeiBo refreshList={this.refreshList} fatherObj={this} currentMedia={this.eidtWeiboMediaCode} weiboId={this.eidtWeiboId} />
                </Modal>
                <MaterialModel visible={this.state.editModalVisible} title={this.weChatParams.title} mediaCode={this.weChatParams.mediaCode} materialId={this.weChatParams.materialId}/>
            </div>
        )
    }

    refreshList = () =>
    {
        this.getMyOtherDate();
        this.closeWeibo();
    }

    //查看按钮，不同的流程，不同的媒体弹不同的框
    chekcData(record) {
        let obj = record.object;
        if (record.actButton.deploymentkey.indexOf( "story") == 0 || record.actButton.deploymentkey.indexOf("yuegao") == 0 || record.actButton.deploymentkey.indexOf("activityStory") == 0) {

            if(obj.storyType==1 || obj.storyTypeStr == 'PIC')
            {
                //*广外 -- 活动稿件里有组图稿件
                this.viewGroupPicStory(record);
            }
            else if (obj.mediaCode || record.actButton.deploymentkey.indexOf( "story") == 0 || record.actButton.deploymentkey.indexOf("activityStory") == 0) {
                this.websiteViewStory(record);
            } else { //投稿端
                this.viewStory(record);
            }
        }else if (record.actButton.deploymentkey.indexOf( "fzr") == 0  || record.actButton.deploymentkey.indexOf( "unfzr") == 0) {
            this.showInterview(record);
        } else if (record.actButton.deploymentkey.indexOf( "weixin") == 0) {
            this.weixinViewMaterial(record);
        } else if (record.actButton.deploymentkey.indexOf( "weibo") == 0 ) {
            this.websiteViewWeibo(record);
        } else if (record.actButton.deploymentkey.indexOf( "downloadSource") == 0 ) {
            this.downloadSourceView(record);
        } else if (record.actButton.deploymentkey.indexOf("douyin") ==0 ){
            this.douyinViewMaterial(record);
        } else if (record.actButton.deploymentkey.indexOf("urlstory") ==0 ){
            // this.websiteViewStory(record);
            this.urlStoryView(record);
        }
    }


    /**
     * 查看组图稿件
     * @param record
     */
    viewGroupPicStory(record){
        let that = this
        let obj = record.object;
        let url = "/cm-sites/pms/addContribute/atlasdetail.html?currentStoryId=" + obj.id + "&currentMediaCode=" + obj.mediaCode + "&treeId=" + obj.news.treeId + "&treeContentId=" + obj.news.treeContentId + (record.actButton.id?"&actButtonId="+record.actButton.id:"");
        window.openFull(url, "编辑组图", null, {
                shade: 0.5,
                area: [parseInt(window.document.body.clientWidth * 0.9) + 'px', parseInt(window.document.body.clientHeight * 0.9) + 'px']
            },null,
            function(){
                myReviewGridData(that.props.currentUser, that.updateMyReviewGrid.bind(that));
                that.refreshList();
            });
    }

    //关闭微博和微信弹窗
    closeWeibo = () => {
        this.setState({
            editWeiboVisible: false,
            editModalVisible: false
        });
    };

    updateMyReviewGrid(myAuditdata) {
        let number = 0;
        if(myAuditdata.data && myAuditdata.data.length > 0){
            for(let i = 0;i < myAuditdata.data.length;i++){
                if(myAuditdata.data[i].actButton.deploymentkey === "downloadSource"){
                    number +=1;
                }
            }
        }
        this.setState({
            myAuditdatas: myAuditdata.data,
            needTodoCount:myAuditdata.data?myAuditdata.data.length:0,
            myAuditloading: true,
            downloadSourceNumber:number,
            editModalVisible : false,
            editWeiboVisible : false,
        })
    }

    /**
     * 链接稿件的查看功能
     */
    urlStoryView(record){
        let that = this;
        let data = record;
        let object = data.object;
        let title = "";
        if(object.storyTypeStr.indexOf("WEIBO") ){
            title = "微博链接稿件";
        }else if(object.storyTypeStr.indexOf("WEIBO") ){
            title = "微信链接稿件";
        }
        let url = "/cm-sites/pms/website/wechat/wechatAdd.html?id=" + object._serviceId + "&actButtonId=10&fromHome=home"; //流程id会需要根据部署进行修改！
        if(object._ProcessInstanceId){
            url += "&processInstanceId="+object._ProcessInstanceId;
        }else {
            url += "&processInstanceId=0";
        }
        // window.openFull(url,title,null,null,null,function() {
        //     myReviewGridData(that.props.currentUser, that.updateMyReviewGrid.bind(that));
        // });
        window.layer.open({
            title: title,
            type: 2,
            content: url,
            area: ['800px', '510px'],
            success: function (layero, index) {
                var iframeWin = window[layero.find('iframe')[0]['name']];
            },end: function(){
                myReviewGridData(that.props.currentUser, that.updateMyReviewGrid.bind(that));
                that.getMyOtherDate();
            }
        });
    }

    /**
     * 抖音的查看功能
     */
    douyinViewMaterial(record){
        let that = this;
        let data = record;
        let object = data.object;
        let url = "/cm-sites/pms/douyin/publish.html?currentMedia="+object.mediaCode+"&id="+object.id+"&actButtonId=20";
        window.openFull(url,"抖音",null,null,null,function() {
            myReviewGridData(that.props.currentUser, that.updateMyReviewGrid.bind(that));
            that.getMyOtherDate();
        });
    }

    /**
     * 资源下载申请
     * @param record
     */
    downloadSourceView(record){
        let that = this;
        window.layer.open({
            title: '资源下载审核',
            type: 2,
            content: '/cm-sites/'+ applicationName() +'/downloadApplication/downloadApplication.html?actButtonId=8&id=' + record.object.id,
            area: [parseInt(document.body.clientWidth *  0.76) + 'px',parseInt(document.body.clientHeight * 0.8) + 'px'],
            success: function (layero, index) {
                var iframeWin = window[layero.find('iframe')[0]['name']];
            },end: function(){
                myReviewGridData(that.props.currentUser, that.updateMyReviewGrid.bind(that));
                that.getMyOtherDate();
            }
        });
    }

    /**
     * 微博查看功能
     * @param record
     */
    websiteViewWeibo(record){
        this.eidtWeiboMediaCode = record.object.mediaCode;
        this.eidtWeiboId = record.object.id;
        this.setState({
            editWeiboVisible : true,
            editModalVisible : false,
        })
    }

    /**
     * 微信的查看功能
     */
    weixinViewMaterial(record){
        this.weChatParams = {
            title : "编辑素材",
            materialId : record.object.id,
            mediaCode : record.object.mediaCode
        };
        this.setState({
            editModalVisible : true,
            editWeiboVisible : false,
        })
    }

    /**
     *稿件的查看  unfzr 的查看
     * @param record
     */
    showInterview(record){
        let that = this;
        let interviewId= record.object.interviewId;
        let width=parseInt(window.document.body.clientWidth * 0.9);
        let height=parseInt(window.document.body.clientHeight * 0.9);
        // window.location.hash = '#/interviewTask/interviewTaskdetail/'+interviewId;
        window.openFull("/cm-sites/pms/interviewTask/interviewTaskdetail.html?interviewId="+interviewId,record.title,null,{area:[width+'px',height+'px']},null,function() {
            myReviewGridData(that.props.currentUser, that.updateMyReviewGrid.bind(that));
            that.getMyOtherDate();
        });
    }

    /**
     * 稿件的查看 （投稿端）
     * @param record
     */
    viewStory(record) {
        let that = this;
        var data = record;
        var object = data.object;

        let width=parseInt(window.document.body.clientWidth * 0.9);
        let height=parseInt(window.document.body.clientHeight * 0.9);

        window.openFull("/cm-sites/pms/writing/writingNew.html?eiditStoryId=" + object._serviceId
            + "&processInstanceId=" + object._ProcessInstanceId + "&actButtonId=2",record.title,null,{area:[width+'px',height+'px']},null,function() {
            myReviewGridData(that.props.currentUser, that.updateMyReviewGrid.bind(that));
            that.getMyOtherDate();
        });
    }

    /**
     * 稿件的查看  （管理端）
     * @param record
     */
    websiteViewStory(record) {
        let that = this;

        let width=parseInt(window.document.body.clientWidth * 0.9);
        let height=parseInt(window.document.body.clientHeight * 0.9);
        let synColumns = record.object.news;
        let mainColumnInfo = synColumns.filter(item=>item.mainColumn==1)[0];

        let treeContentId = 0;
        let mediaCode = "";
        if(mainColumnInfo){
            //window.layer.alert("主栏目信息获取错误，无法打开该文章");
            if(mainColumnInfo.treeContentId){
                treeContentId = mainColumnInfo.treeContentId;
            }
            if(mainColumnInfo.mediaCode){
                mediaCode = mainColumnInfo.mediaCode;
            }
        }
        let interviewId = record.interviewId || 0;
        window.openFull("/cm-sites/pms/addContribute/addContributeNews.html?interviewId=" + interviewId+ "&eiditStoryId=" + record.object._serviceId+"&processInstanceId="+record.object._ProcessInstanceId+"&treeContentId="+treeContentId+"&currentMediaCode="+ (mediaCode || record.object.mediaCode)  + "&passMediaCodes=" + (mediaCode  || record.object.mediaCode)
            + "&actButtonId="+record.actButton.id,record.title,null,{area:[width+'px',height+'px']},null,function(){
            myReviewGridData(that.props.currentUser, that.updateMyReviewGrid.bind(that));
            that.refreshList();
        });

    }

    /**
     * 获取标题
     * @param recorde
     */
    getTitle(recorde) {
        let obj = recorde.object;
        let returnObj = {};
        let title = "";
        let type = "";
        if (recorde.actButton.deploymentkey.indexOf("story") === 0 || recorde.actButton.deploymentkey === "yuegao"
            || recorde.actButton.deploymentkey === "fzr" || recorde.actButton.deploymentkey === "unfzr" || recorde.actButton.deploymentkey === "activityStory") {
            if(recorde.actButton.deploymentkey === "fzr" || recorde.actButton.deploymentkey === "unfzr"){
                title = "(采访任务稿件)" + obj.title;
            }else{
                title = obj.title;
            }
            type = "稿件";
        } else if (recorde.actButton.deploymentkey === "weixin") {
            if(obj.stuffList && obj.stuffList[0]){
                title = obj.stuffList[0].title;
            }
            type = "微信";
        } else if (recorde.actButton.deploymentkey === "weibo") {
            title = obj.content;
            type = "微博";
        } else if (recorde.actButton.deploymentkey === "downloadSource") {
            title = recorde.object.userName + "-" + recorde.object.deptName +"-" + window.formatDate(recorde.object.createTime).substring(0,10);
            type = "资源下载申请";
        } else if (recorde.actButton.deploymentkey === "douyin"){
            title = obj.title;
            type = "抖音";
        } else if (recorde.actButton.deploymentkey === "urlstory"){
            if(obj.storyTypeStr === "WECHAT"){
                title = obj.title;
                type = "微信链接稿件";
            }else if(obj.storyTypeStr === "WEIBO"){
                title = obj.title;
                type = "微博链接稿件";
            }
        } else if (recorde.actButton.deploymentkey === "activityStory_GWNews"){
            title = "(新闻任务稿件)" + obj.title;
            type = "稿件";
        }
        returnObj.title = title;
        returnObj.type = type;
        return returnObj;
    }

    /**
     * 获取标题
     * @param recorde
     */
    getIcon(recorde) {
        let li = "";
        if (recorde.actButton.deploymentkey.indexOf("story") === 0 || recorde.actButton.deploymentkey === "yuegao"
            || recorde.actButton.deploymentkey === "fzr" || recorde.actButton.deploymentkey === "unfzr" || recorde.actButton.deploymentkey === "activityStory") {
            li='icon icon-pc';
        } else if (recorde.actButton.deploymentkey === "weixin") {
            li='icon icon-wechat';
        } else if (recorde.actButton.deploymentkey === "weibo") {
            li='icon icon-wb';
        } else if (recorde.actButton.deploymentkey === "downloadSource") {
            li='icon icon-downloadSource';
        } else if (recorde.actButton.deploymentkey === "douyin"){
            li='icon icon-dy';
        }
        return li;
    }
}

function mapStateToProps(state){
    return {
        navigateStatus:state.systemReducer.navigateStatus,
    }
}
export default connect(mapStateToProps)(ActivityPendingComponentsOtherGwxw);

export const getMyOther = (callBack)=> {
    let url = "/cm-sites-activiti/activiti/getNeedProcessedAll";
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getMyInterView",error);
        callBack("");
    })
};